
import Axios  from './axios'

// 分类列表api
export const categoryList =  ()=> {
	return Axios.post('learn/cate/get').then(res=>res.data);
}
// 分类列表树
export const categoryTree =  ()=> {
	return Axios.post('learn/cate/tree').then(res=>res.data);
}
//所有训练列表
export const  courseAllList = (params)=>{
  return Axios.post(`learn/get`,params).then(res=>res.data);
}
// 班级训练列表
export const  courseList = (params)=>{
  return Axios.post(`learn/get_class_learn`,params).then(res=>res.data);
}
//用户信息
export const getUserInfo =  ()=> {
  return Axios.post('user/get_info').then(res=>res.data);
}
//修改用户信息
export const updateUserInfo =  (params)=> {
  return Axios.post('user/edit_info',params).then(res=>res.data);
}
// 上传文件
export const uploadFile =  (params)=> {
  return Axios.post('common/upload_file',params).then(res=>res.data);
}
// 重置密码
export const updatePassword =  (params)=> {
  return Axios.post('user/edit_password',params).then(res=>res.data);
}
// 重置密码
export const resetPassword =  (params)=> {
  return Axios.post('user/reset_password',params).then(res=>res.data);
}
// 学生成绩
export const getScore =  (params)=> {
  return Axios.post('score/get_student',params).then(res=>res.data);
}
// 学生成绩详情
export const getScoreDetail =  (params)=> {
  return Axios.post('score/get_one_score',params).then(res=>res.data);
}
// 课程详情顶部数据
export const courseTop = (courseid)=>{
	return Axios.get(`/course/${courseid}/top/`).then(res=>res.data);
}
// 课程概述
export const coursePaymentInfo = (courseid)=>{
	return Axios.get(`course/${courseid}/payment_info/`).then(res=>res.data);
}

// geetest接口
export const geetest = ()=>{
	return Axios.get(`captcha_check/`).then(res=>res.data);
}

// 登录
export const  userLogin = (params)=>{
	// 这个参数至少有五个字段 username password  验证的三个字段
	return Axios.post('user/login',params).then(res=>res.data);
}
// 加入购物车的接口
export const shopCart = (params)=>{
    console.log(params)
	return Axios.post('user/shop_cart/create/',params).then(res=>res.data);
}
// 购物车的数据
export const shopCartList = ()=>{
	return Axios.get(`user/shop_cart/list/`).then(res=>res.data);
}
export const removeCourse = (params)=>{
    // params = QS.stringify(params);
    // console.log(params);
    // 如果服务端将参数当做 java对象来封装接收则 参数格式为：{data: param}
    return Axios.delete(`user/shop_cart/remove/`,{data: params}).then(res=>res.data);
}

//更新购物车套餐数据
export const shopCartUpdate = (params)=>{
    return Axios.put(`user/shop_cart/update/`,params).then(res=>res.data);
}
export const order_confirm = (params)=>{
    return Axios.post('/order/confirm/',params).then(res=>res.data)
}
//获取验证码
export const getCode = (params)=>{
  return Axios.get('/user/captcha/',params).then(res=>res.data)
}
//验证验证码
export const validateCode = (params)=>{
  return Axios.post(`user/captcha/validate`,params).then(res=>res.data)
}
//获取随机码
export const getsjCode = (params)=>{
  return Axios.post(`score/get_check_code`,params).then(res=>res.data)
}

//作业列表
export const taskclass = (params)=>{
  return Axios.post('task/get_class',params).then(res=>res.data)
}
//作业状态
export const taskstatus = (params)=>{
  return Axios.post('task/get_student_status',params).then(res=>res.data)
}
//考试列表
export const testclass = (params)=>{
  return Axios.post('test/get_class',params).then(res=>res.data)
}
//考试状态
export const teststatus = (params)=>{
  return Axios.post('test/get_student_status',params).then(res=>res.data)
}


// WEBPACK FOOTER //
// ./src/restful/api.js